import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";
import { useTheme } from "./ThemeProvider";

// Scope dark mode to the tenant dashboard only. Applying `.dark` in a
// useLayoutEffect (rendered eagerly, outside <Suspense>) toggles the class
// before paint, so there is no flash. The predicate deliberately excludes
// /kzool-admin/dashboard — only /dashboard(/*) gets dark mode.
export default function ThemeRouteScope() {
  const { theme } = useTheme();
  const { pathname } = useLocation();
  useLayoutEffect(() => {
    const onDashboard = pathname === "/dashboard" || pathname.startsWith("/dashboard/");
    document.documentElement.classList.toggle("dark", onDashboard && theme === "dark");
  }, [theme, pathname]);
  return null;
}
